import { createContext, useContext, useEffect, useState } from 'react'
import { RequestService } from '../services/RequestService'

const UserFullListContext = createContext()

export const UserFullListProvider = ({ children }) => {
  const [rows, setRows] = useState([])
  const [levelCount, setlevelCount] = useState([])
  const [loading, setLoading] = useState(true)
  const [loadingFilters, setLoadingFilters] = useState(true)
  const [filterOptions, setFilterOptions] = useState(null)
  const [selectedFilterOptions, setSelectedFilterOptions] = useState([])
  const [selectedUser, setSelectedUser] = useState(null)
  const [inputValue, setInputValue] = useState('')


  const onSelectFilter = value => {
    setSelectedUser(null)
    setInputValue('')
    setSelectedFilterOptions(value)
  }

  const onSelectUser = value => {
    setSelectedUser(value)
    setInputValue(value.name)
    setSelectedFilterOptions([])
  }


  const fetchData = async () => {
    if (!loading) setLoading(true)

    try {
      const { data } = await RequestService.getUserFullList({
        selectedFilterOptions,
        selectedUserId: selectedUser?.id,
      })
      setRows(data?.userList || [])
      setlevelCount(data?.levelCount || [])
    } catch (error) {
      console.error('Error on data fetch', error)
    }

    setLoading(false)
  }

  const getPossibleFilters = async () => {
    if (!loadingFilters) setLoadingFilters(true)

    try {
      const { data } = await RequestService.getUserFullListFilters()
      setFilterOptions(data)
    } catch (error) {
      console.error('Error on data fetch filters', error)
    }

    setLoadingFilters(false)
  }

  useEffect(() => {
    fetchData()
  }, [selectedFilterOptions, selectedUser?.id])

  useEffect(() => {
    getPossibleFilters()
  }, [])

  return (
    <UserFullListContext.Provider
      value={{
        rows,
        levelCount,
        loading,
        loadingFilters,
        filterOptions,
        onSelectFilter,
        selectedFilterOptions,
        selectedUser,
        onSelectUser,
        inputValue,
        onInputValueChange: setInputValue,
      }}
    >
      {children}
    </UserFullListContext.Provider>
  )
}

export const useUserFullList = () => {
  return useContext(UserFullListContext)
}
